export default __webpack_public_path__ + "static/media/gallery-3.461d3491.jpg";